<template>
  <div
    id="team"
    class="team-container"
  >
    <div class="team-part-wrapper content-part-wrapper">
      <div class="team-title-wrapper content-title-wrapper">
        <h3>{{$t('FOUNDER')}}</h3>
        <span class="title-line"></span>
      </div>
      <div class="team-members-container">
        <div
          v-for="(item, index) in
           team"
          class="team-member"
          id="introduction"
        >
          <div class="team-member-pic" v-if="item.picture">
            <img class="lazyload-el" :src="item.picture" :data-src="item.picture">
          </div>
          <div class="team-member-content">
            <div class="team-member-name-position">
              <div class="team-member-name">
                {{item.name}}
                <a
                  target="_blank"
                  class="team-linkedIn"
                  :href="item.linkdin"
                >
                  <img src="../../assets/pagefounder/Linkedln.png">
                </a>
              </div>
            </div>
            <p class="team-member-introduction">
              {{item.introduction}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en": {
    "FOUNDER": "FOUNDER"
  },
  "zn": {
    "FOUNDER": "团队成员"
  }
}
</i18n>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "PcLogin",
  props: {},
  data() {
    return {
      team: [],
      teamEn: [
        {
          name: "Psymon Li",
          // position: 'CEO',
          introduction: `CEO of Meituan Cloud, former director of Network Department of Alibaba, former chairman of Baidu System Technology Committee.`,
          picture: require("../../assets/pagefunderCarton/ceo.png"),
          linkdin: "https://www.linkedin.com/in/psymon-li-84058780/"
        },
        {
          name: "Grace Gao",
          // position: 'COO',
          introduction: `General manager of CISCO XaaS and Cloud Partner Greater China, former director of global technology strategy cooperation of Alibaba.`,
          picture: require("../../assets/pagefunderCarton/grace.png"),
          linkdin: "https://www.linkedin.com/in/grace-yabin-gao-74953a12b/"
        },
        {
          name: "Sid Wong",
          // position: 'CTO',
          introduction: `CTO of Meituan Cloud, former director of network product R&D of Alibaba Cloud and Alipay, former technique manager of Baidu CDN.`,
          picture: require("../../assets/pagefunderCarton/sid.png"),
          linkdin: "https://www.linkedin.com/in/sid-wong-091aa69b/"
        },
        {
          name: "Sean Ley",
          // position: 'System Operation Lead',
          introduction: `Former head of SRE and Devops of Meituan Cloud, Meituan Dianping technical expert , former senior system engineer of Baidu.`,
          picture: require("../../assets/pagefunderCarton/ley.png"),
          linkdin: "https://www.linkedin.com/in/sean-ley-b33480170/"
        },
        {
          name: "Will Wong",
          // position: 'Network R&D Lead',
          introduction: `Former Meituan Dianping network and security technical expert，former senior network and security engineer of Sangfor.`,
          picture: require("../../assets/pagefunderCarton/will.png"),
          linkdin: "https://www.linkedin.com/in/will-wong-6889bb172/"
        },
        {
          name: "Felix Ying",
          position: "Blockchain R&D Lead",
          introduction: `Former head of Storage team of Meituan Cloud. Meituan Dianping technical expert. Abundant experience in distributed systems and high concurrency systems.`,
          picture: require("../../assets/pagefunderCarton/ying.png"),
          linkdin: "https://www.linkedin.com/in/felix-ying-304a01172/"
        },
        {
          name: "Lemon Li",
          position: "",
          introduction: `Former Meituan cloud container platform leader, Meituan technical expert.`,
          picture: require("../../assets/pagefunderCarton/wenjun.png"),
          linkdin: "https://www.linkedin.com/in/wenjun-li-55ba317b/"
        },
        {
          name: "Geiger Gao",
          position: "Hardware R&D Lead",
          introduction: `A senior IT industry expert with more than 15 years of experience in Information Communications Technology. He was responsible for planning and designing multiple carrier-level products.`,
          picture: require("../../assets/pagefunderCarton/geiger.png"),
          linkdin: "https://www.linkedin.com/in/geiger-gao-28710637/"
        },
        {
          name: "Shawn Wong",
          position: "Brand Director",
          introduction: `Senior brand public relations expert and public opinion big data expert,has many years of experience in the field of Internet marketing and new media communication.For SMG, Youku and dozens of first-line stars, many years of marketing public relations and public opinion big data services.`,
          picture: require("../../assets/pagefunderCarton/Shawn.png")
        },
        {
          name: "Candice Chen",
          // position: 'senior front-end developer',
          introduction: `Former Meituan senior front-end developer, lecturer  of Meituan Internet + college, former senior front-end developer of iQiyi.`,
          picture: require("../../assets/pagefunderCarton/chen.png"),
          linkdin: "https://www.linkedin.com/in/%E7%91%B6-%E9%99%88-875a56a3/"
        },
        {
          name: "Yuqing Chen",
          position: "HRD",
          introduction: `Former Meituan HRBP，worked in Baidu and Russell Reynolds Associates，expert in recruiting，compensation and benefit.`,
          picture: require("../../assets/pagefunderCarton/yuqin.png"),
          linkdin: "https://www.linkedin.com/in/yuqing-chen-a1911047/"
        },
        {
          name: "Sinan Wong",
          position: "",
          introduction: `Former Meituan Dianping network and security technical expert，former senior network and security engineer of Sangfor.`,
          picture: require("../../assets/pagefunderCarton/sinan.png"),
          linkdin: "https://www.linkedin.com/in/sinan-wong-4aa028b8/"
        },
        {
          name: "Vincent Guo",
          position: "",
          introduction: `Former Meituan senior network R&D engineer, former Meituan Cloud senior network R&D engineer.`,
          picture: require("../../assets/pagefunderCarton/vincent.png"),
          linkdin: "https://www.linkedin.com/in/vincent-guo-0339bb172/"
        },
        {
          name: "Lorraine Lo",
          position: "",
          introduction: `Former Secretary for International Affairs of CEO’s Office of Phoenix TV, once worked in Antena 3 (Spain) Asia as News Producer.`,
          picture: require("../../assets/pagefunderCarton/lorilo.png"),
          linkdin: "https://www.linkedin.com/in/罗苑晴-lorraine-73937161/"
        },
        {
          name: "Anton Skorzewski",
          position: "",
          introduction: `Russian speaking Community Operations Leader, Deputy Director General of China Metallurgical Construction Engineering Group CO.,LTD.,Ukraine.`,
          picture: require("../../assets/pagefunderCarton/Skorzewski_carton.png"),
          linkdin: "https://www.linkedin.com/in/%D0%B0%D0%BD%D1%82%D0%BE%D0%BD-%D1%81%D0%BA%D0%BE%D1%80%D0%B6%D0%B5%D0%B2%D1%81%D0%BA%D0%B8%D0%B9-81bb4b78/"
        },
        {
          name: "Vitaliy Davitiani",
          introduction: `Russian speaking Community Operations Technical Leader, Automotive Embedded Software Developer`,
          picture: require("../../assets/pagefunderCarton/davitiani.png"),
          linkdin: ""
        }
      ],
      teamZn: [
        {
          name: "Psymon Li",
          introduction: `云计算行业领军人，拥有10余年经验的资深云计算领域专家。曾任美团云总经理、阿里巴巴集团网络总监、百度系统技术委员会主席，历经云计算行业从无到有。李爽构建的博纳云旨在积极探索以区块链技术为核心的分布式云计算平台，目的是打造下一代的IT基础设施。`,
          picture: require("../../assets/pagefunderCarton/ceo.png"),
          linkdin: "https://www.linkedin.com/in/psymon-li-84058780/"
        },
        {
          name: "Grace Gao",
          introduction: `具有20年+OTT/运营商从业经验和拥有融合技术、销售、产品、战略与合作等资深经历；前思科中国协作产品大中国区负责人/SaaS业务及云合作伙伴大中国区负责人；前阿里巴巴——阿里云国际东南亚及澳洲BD团队负责人/集团技术保障部资深专家。`,
          picture: require("../../assets/pagefunderCarton/grace.png"),
          linkdin: "https://www.linkedin.com/in/grace-yabin-gao-74953a12b/"
        },
        {
          name: "Sid Wong",
          introduction: `资深云计算与网络研发专家。前美团云CTO；前阿里巴巴、支付宝网络研发总监，负责支付宝流量调度系统建设，阿里云SLB、权威DNS，公共DNS等产品研发；前百度CDN技术经理，参与创建了百度第一代CDN系统。`,
          picture: require("../../assets/pagefunderCarton/sid.png"),
          linkdin: "https://www.linkedin.com/in/sid-wong-091aa69b/"
        },
        {
          name: "Sean Ley",
          introduction: `前美团云运维负责人，美团技术专家，曾任百度高级系统工程师。`,
          picture: require("../../assets/pagefunderCarton/ley.png"),
          linkdin: "https://www.linkedin.com/in/sean-ley-b33480170/"
        },
        {
          name: "Will Wong",
          introduction: `美团点评网络安全技术专家，曾任深信服高级网络安全工程师。`,
          picture: require("../../assets/pagefunderCarton/will.png"),
          linkdin: "https://www.linkedin.com/in/will-wong-6889bb172/"
        },
        {
          name: "Felix Ying",
          position: "Blockchain R&D Lead",
          introduction: `前美团云存储组负责人，美团技术专家，分布式系统专家。`,
          picture: require("../../assets/pagefunderCarton/ying.png"),
          linkdin: "https://www.linkedin.com/in/felix-ying-304a01172/"
        },
        {
          name: "Lemon Li",
          introduction: `前美团云容器平台负责人，美团技术专家。`,
          picture: require("../../assets/pagefunderCarton/wenjun.png"),
          linkdin: "https://www.linkedin.com/in/wenjun-li-55ba317b/"
        },
        {
          name: "Geiger Gao",
          position: "Hardware R&D Lead",
          introduction: `资深IT行业专家，拥有15年以上的电信、网络协议、通信领域行业经验，曾负责多个运营商级别产品规划设计。`,
          picture: require("../../assets/pagefunderCarton/geiger.png"),
          linkdin: "https://www.linkedin.com/in/geiger-gao-28710637/"
        },
        {
          name: "Shawn Wong",
          position: "Brand Director",
          introduction: `资深品牌公关专家与舆情大数据专家，在互联网营销及新媒体传播等领域具有多年行业经验，为SMG、优酷等公司和数十位一线明星提供多年营销公关及舆情大数据服务。`,
          picture: require("../../assets/pagefunderCarton/Shawn.png")
        },
        {
          name: "Candice Chen",
          // position: 'senior front-end developer',
          introduction: `前美团资深前端开发工程师，美团互联网+学院讲师；曾任爱奇艺高级前端工程师`,
          picture: require("../../assets/pagefunderCarton/chen.png"),
          linkdin: "https://www.linkedin.com/in/%E7%91%B6-%E9%99%88-875a56a3/"
        },
        {
          name: "Yuqing Chen",
          position: "HRD",
          introduction: `曾任美团HRBP，曾在百度和Russell Reynolds Associates工作，是招聘，薪酬和福利方面的专家。`,
          picture: require("../../assets/pagefunderCarton/yuqin.png"),
          linkdin: "https://www.linkedin.com/in/yuqing-chen-a1911047/"
        },
        {
          name: "Sinan Wong",
          position: "",
          introduction: `曾任美团产品运营专家，美团云高级业务分析。`,
          picture: require("../../assets/pagefunderCarton/sinan.png"),
          linkdin: "https://www.linkedin.com/in/sinan-wong-4aa028b8/"
        },
        {
          name: "Vincent Guo",
          position: "",
          introduction: `美团点评高级网络研发工程师，前美团云高级网络研发工程师`,
          picture: require("../../assets/pagefunderCarton/vincent.png"),
          linkdin: "https://www.linkedin.com/in/vincent-guo-0339bb172/"
        },
        {
          name: "Lorraine Lo",
          position: "",
          introduction: `前凤凰卫视行政总裁办公室海外事务秘书，曾在西班牙著名商业电视台Antena 3担任亚洲分社新闻制片人。`,
          picture: require("../../assets/pagefunderCarton/lorilo.png"),
          linkdin: "https://www.linkedin.com/in/罗苑晴-lorraine-73937161/"
        },
        {
          name: "Anton Skorzewski",
          introduction: `俄语社区运营负责人，乌克兰中国冶金建设工程集团有限公司副总干事。`,
          picture: require("../../assets/pagefunderCarton/Skorzewski_carton.png"),
          linkdin:
            "https://www.linkedin.com/in/%D0%B0%D0%BD%D1%82%D0%BE%D0%BD-%D1%81%D0%BA%D0%BE%D1%80%D0%B6%D0%B5%D0%B2%D1%81%D0%BA%D0%B8%D0%B9-81bb4b78/"
        },
        {
          name: "Vitaliy Davitiani",
          introduction: `俄语社区运营技术负责人，嵌入式软件开发。`,
          picture: require("../../assets/pagefunderCarton/davitiani.png")
        }
      ]
    };
  },
  computed: mapState({
    isZnWebsite: state => state.isZnWebsite,
  }),
  methods: {
    ...mapActions([])
  },
  created() {
    this.$i18n.locale = this.isZnWebsite ? "zn" : "en";

    if (this.isZnWebsite ) {
      this.team = this.teamZn;
    } else {
      this.team = this.teamEn;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.team-part-wrapper {
  margin-bottom: 50px;

  .team-members-container {
    margin: 0 12%;
  }

  .team-member {
    margin-bottom: 30px;
    min-height: 150px;
    box-sizing: border-box;
    display: inline-block;
    width: 49%;
    padding: 0 10%;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
    position: relative;

    .team-member-pic {
      vertical-align: top;
      display: inline-block;
      box-sizing: border-box;
      padding-right: 10px;
      width: 200px;
      height: 200px;
      overflow: hidden;
      // border-radius: 50%;
      // background-color: #fff;
      background-size: cover;

      img {
        width: 100%;
        filter: sepia(53%);
        filter: opacity(91%);
        filter: saturate(50%);
        // -webkit-filter: grayscale(100%);
        // filter: grayscale(100%);
      }
    }

    .team-member-content {
      display: inline-block;
      margin-top: 20px;
      width: 65%;
    }

    .team-member-name-position {
      // position: absolute;
      // left: 10px;
      // top: 0px;
      .team-member-name {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
        font-size: 25px;
      }

      .team-member-name:after {
        display: block;
        width: 20px;
        height: 20px;
        background-image: url('../../assets/pagefounder/Linkedln.png');
      }

      .team-member-position {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 12px;
      }

      a.team-linkedIn {
        display: inline-block;
        width: 20px;
        height: 20px;

        img {
          margin-left: 10px;
          height: 20px;
          width: 20px;
        }
      }
    }

    .team-member-introduction {
      font-size: 12px;
    }
  }
}

@media (max-width: 720px) {
  .team-part-wrapper {
    .team-members-container {
      margin: 0;
    }

    .team-member {
      margin-bottom: 20px;
      min-height: auto;
      width: 100%;
      padding: 0;

      .team-member-content {
        margin-top: 15px;
      }
    }
  }
}
</style>
